import { REPORT_SEVERITY } from "static/constants";

export const rowStyle = (rowData, role, view, theme) => {
  const physician = localStorage.getItem("physician") === "true";
  const clinicReviewer = localStorage.getItem("clinicReviewer") === "true";

  const isBackBill =
    rowData.moved_for_backbill &&
    view === "active" &&
    !physician &&
    !clinicReviewer &&
    role !== "clinic";

  const warningFlag =
    rowData.warning_flag ??
    (Array.isArray(rowData?.reportNotes?.evoke_notes)
      ? rowData?.reportNotes?.evoke_notes?.some((note) =>
          note.content?.some(({ alert }) => alert === REPORT_SEVERITY[2])
        )
      : false);

  if (rowData?.returned && !rowData.alert_flag && !warningFlag) {
    return {
      backgroundColor:
        theme.palette.type === "light"
          ? "rgba(211,211,211) !important"
          : "#515151 !important",
    };
  } else if (rowData?.returned && rowData.alert_flag) {
    return {
      backgroundColor:
        theme.palette.type === "dark"
          ? "#5F2120 !important"
          : "rgba(239, 83, 80, 0.15) !important", // light red
      border: "4px solid rgba(211,211,211) !important", // light grey
      borderWidth: "4px 0px 4px 0px !important",
    };
  } else if (rowData?.returned && warningFlag) {
    return {
      backgroundColor:
        theme.palette.type === "dark"
          ? "#5F2120 !important"
          : "rgba(255, 152, 0, 0.15) !important", // light yellow
      border: "4px solid rgba(211,211,211) !important", // light grey
      borderWidth: "4px 0px 4px 0px !important",
    };
  } else if (rowData.alert_flag && !rowData.clinic_billed && !isBackBill) {
    return {
      backgroundColor:
        theme.palette.type === "dark"
          ? "#5F2120 !important"
          : "rgba(239, 83, 80, 0.15) !important", // light red
    };
  } else if (warningFlag && !rowData.clinic_billed && !isBackBill) {
    return {
      backgroundColor:
        theme.palette.type === "dark"
          ? "#5F2120 !important"
          : "rgba(255, 152, 0, 0.15) !important", // light yellow
    };
  } else if (rowData.alert_flag && rowData.clinic_billed && !isBackBill) {
    return {
      backgroundColor:
        theme.palette.type === "dark"
          ? "#5F2120 !important"
          : "rgba(239, 83, 80, 0.25) !important", // light red
      border: "4px solid rgba(83, 130, 255, 0.15) !important", // light blue
      borderWidth: "4px 0px 4px 0px !important",
    };
  } else if (warningFlag && rowData.clinic_billed && !isBackBill) {
    return {
      backgroundColor:
        theme.palette.type === "dark"
          ? "#5F2120 !important"
          : "rgba(255, 152, 0, 0.3) !important", // light yellow
      border: "4px solid rgba(83, 130, 255, 0.15) !important", // light blue
      borderWidth: "4px 0px 4px 0px !important",
    };
  } else if (rowData.alert_flag && isBackBill) {
    return {
      backgroundColor:
        theme.palette.type === "dark"
          ? "#5F2120 !important"
          : "rgba(239, 83, 80, 0.25) !important", // light red
      border: "4px solid rgba(76, 175, 80, 0.15) !important", // light yellow
      borderWidth: "4px 0px 4px 0px !important",
    };
  } else if (warningFlag && isBackBill) {
    return {
      backgroundColor:
        theme.palette.type === "dark"
          ? "#5F2120 !important"
          : "rgba(255, 152, 0, 0.3) !important", // light yellow
      border: "4px solid rgba(76, 175, 80, 0.15) !important", // light green
      borderWidth: "4px 0px 4px 0px !important",
    };
  } else if (isBackBill) {
    return {
      backgroundColor: "rgba(76, 175, 80, 0.15) !important", // light green
    };
  } else if (!rowData.alert_flag && rowData.clinic_billed) {
    return {
      backgroundColor: "rgba(83, 130, 255, 0.15) !important", // light blue
    };
  } else if (rowData?.returned) {
    return {
      backgroundColor: "rgba(211,211,211) !important", // light grey
    };
  } else {
    return {
      backgroundColor: `${theme.palette.background.paper} !important`,
    };
  }
};
